import React from 'react';
import { Link } from 'react-router-dom';

const VerificationSent = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-10 bg-white rounded-lg shadow-md">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Verification Email Sent
          </h2>
        </div>
        
        <div className="mt-2 text-center text-md text-gray-600">
          <p>
            We've sent a verification email to your inbox. Please check your email and click the verification link to activate your account.
          </p>
          <p className="mt-4">
            If you don't receive the email within a few minutes, please check your spam folder.
          </p>
        </div>
        
        <div className="mt-6">
          <Link 
            to="/login" 
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-blue hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-blue"
          >
            Return to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VerificationSent;